const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_TAX_CATEGORIES':
      return action.taxCategories;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/taxCategories.js